import TempManage  from './TempManage.vue'
export default TempManage
